import React, { useMemo } from 'react';

import { TreeItem, TreeItemCheckEvent, TreeItems } from './Tree.types';
import TreeItemNode from './TreeItemNode/TreeItemNode';

interface Props {
  items: TreeItems;
  parent?: TreeItem;
  treeId: string;
  onItemCheck: (event: TreeItemCheckEvent) => void;
}

const TreeGroup: React.FC<Props> = React.memo(({ items, parent = {}, treeId, onItemCheck }) => {
  const render = useMemo(() => {
    return items.map((item: TreeItem) => {
      return (
        <TreeItemNode
          key={item.id}
          isHidden={!!(item.hidden || (parent.id && parent.hidden))}
          item={item}
          treeId={treeId}
          onCheck={onItemCheck}
        />
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, parent]);

  return <>{render}</>;
});

export default TreeGroup;
